// Administered under backend `permission_management` submodule (REBUILD-PLAN §5.3).
// Module id and permission namespace are separate per §4.1/§5.5 — earlier revisions
// unified them, breaking real-user access once Phase 10 swapped MSW for HTTP.
//
// Lives in its own file (not inline in rolesFeature.ts) so route factories and
// screens can import these constants without a circular import back through
// rolesFeature.ts -> presentation/routes -> here.
const PERMISSION_MANAGEMENT = "core.permission_management";
const PERMISSION_MANAGEMENT_LIST = `${PERMISSION_MANAGEMENT}.permission_management_list`;

export const PERMISSION_MANAGEMENT_VIEW = `${PERMISSION_MANAGEMENT_LIST}.view`;
export const PERMISSION_MANAGEMENT_CREATE = `${PERMISSION_MANAGEMENT_LIST}.create`;
export const PERMISSION_MANAGEMENT_UPDATE = `${PERMISSION_MANAGEMENT_LIST}.update`;
export const PERMISSION_MANAGEMENT_DELETE = `${PERMISSION_MANAGEMENT_LIST}.delete`;
